import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop, get } from 'lodash-es'
import Button from '@components/Button'
import PhotoPreview from '@components/PhotoPreview'
import ProgressIndicator from '../../../components/ProgressIndicator'
import HorizontalSpinner from '@components/HorizontalSpinner.tsx'
import SVGIcon from '../../../components/SVGIcon'

export default class PhotoLibraryItem extends Component {
  static propTypes = {
    photo: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool,
  }

  static defaultProps = {
    onSelect: noop,
    onDelete: noop,
    isDeleting: false,
  }

  didSelectItemHandler = () => {
    const { photo, onSelect } = this.props
    onSelect(photo.id)
  }

  clickDeleteHandler = () => {
    const { photo, onDelete } = this.props
    onDelete(photo.id)
  }

  getImageContent() {
    const { photo } = this.props
    const imageProcessingComplete =
      get(photo, 'image_processing_complete') === true ||
      get(photo, ['attributes', 'image_processing_complete']) === true
    if (imageProcessingComplete) {
      return <PhotoPreview key={`photo_preview_${photo.id}`} photo={photo} thumbnailStyle="large_square" />
    }
    return null
  }

  getProgressIndicatorContent() {
    const { photo, isDeleting } = this.props
    if (isDeleting) {
      return (
        <div className="progress-container">
          <HorizontalSpinner />
        </div>
      )
    } else if (
      get(photo, ['image_processing_complete']) === false ||
      get(photo, ['attributes', 'image_processing_complete']) === false
    ) {
      return <ProgressIndicator hint="Processing" alwaysHint={true} />
    }
    return null
  }

  render() {
    const imageContent = this.getImageContent()
    const progressIndicator = this.getProgressIndicatorContent()
    return (
      <div className="photo-library__photo-item photo-item">
        <div className="content">
          <div
            className="photo-item__selector"
            onClick={this.didSelectItemHandler}
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && this.didSelectItemHandler(e)}
            aria-label="Select image"
          >
            {imageContent}
            <div className="photo-item__overlay"></div>
          </div>
          <Button
            onClick={this.clickDeleteHandler}
            className="button-reset top-right-cross"
            tabIndex={0}
            title="Delete image"
          >
            <SVGIcon xlinkHref="#streamline-delete-1" alt="Delete" className="icon-shadow" pointerEvents="none" />
          </Button>
          {progressIndicator}
        </div>
      </div>
    )
  }
}
